import React from 'react';
import { useUiTheme } from 'framework/uiTheme';
import useFieldHelper from '../fieldHelper';
import { BaseFieldLayoutType, FieldProps } from '../types';

const PercentField = (props: FieldProps<string | number>) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const initialValue = +getValue();
  const value = initialValue || initialValue === 0 ? `${getValue()}%` : null;

  return <BaseFieldLayout {...props} label={getLabel()} value={value} />;
};

export default PercentField;
